var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('delivery-form',{attrs:{"title":"ساخت نرخ","submitFunction":_vm.createDelivery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }